function closecart() {
    document.querySelector(".latest-cart-drawer").classList.remove("r-0");
    document.querySelector("#overlay").classList.remove("open");
    document.querySelector("body").style.overflowY = 'visible';
}

function opencart() {
    document.querySelector(".latest-cart-drawer").classList.add("r-0");
    document.querySelector("#overlay").classList.add("open");
    document.querySelector("body").style.overflowY = 'hidden';
}

function updatecart(url) {
    fetch(url).then(function (response) {
        // The API call was successful!
        return response.text();
    }).then(function (html) {
        // Convert the HTML string into a document object
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        document.querySelector(".cart-count").innerHTML = doc.querySelector(".cart-count").innerHTML;
        document.querySelector('.latest-cart-drawer').innerHTML = doc.querySelector(".latest-cart-drawer").innerHTML;
        opencart();
    }).catch(function (err) {
        // There was an error
        console.warn('Something went wrong.', err);
    });
}

function addtocart(form, button) {
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(form);
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
            updatecart('/cart');
            button.removeAttribute("disabled");
        })
        .catch((e) => {
            console.error(e);
            button.removeAttribute("disabled");
        })
        .finally(() => {
            updatecart('/cart');
            button.removeAttribute("disabled");
        });
}

if (document.querySelector(".latest-add-to-cart-btn")) {
    document.querySelector(".latest-add-to-cart-btn").addEventListener("click", function (e) {
        e.preventDefault();
        this.setAttribute("disabled", "disabled");
        var form = this.parentElement.parentElement;
        var qty = 1;
        var id = parseInt(form.querySelector("[name=id]").value);
        addtocart(form, this)
        // jQuery.post('/cart/add.js', {
        //     items: [
        //       {
        //         quantity: qty,
        //         id: id
        //       }
        //     ]
        //   }).done(function(){
        //     updatecart('/cart/update')
        //   });
    });
}

// document.querySelectorAll(".product_hover").forEach(function (product) {
//     product.addEventListener("mouseover", function () {
//         var description = this.querySelector(".product-description");
//         var updatedescription = document.querySelector(".collection_list_section .product-heading");
//         if (description) {
//             updatedescription.textContent = description.textContent;
//         }
//         else {
//             updatedescription.textContent = "";
//         }
//     });
// });